export const calculateBusinessDays = (startDate, endDate) => {
  let currentDate = new Date(startDate);
  // console.log(currentDate,startDate, endDate, '7777777777777777777777');
  let weekendCount = 0;

  // Iterate through each day
  while (currentDate <= new Date(endDate)) {
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
    // console.log(currentDate, dayOfWeek, 'day of week---------');
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      weekendCount++;
    }
    currentDate.setUTCDate(currentDate.getUTCDate() + 1); // Move to the next day
  }
  // console.log(weekendCount, 'weekendCount==========================18');
  const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1; // Including start and end date
  return totalDays - weekendCount; // Subtract weekends
};
